import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { FaCopyright } from 'react-icons/fa';

const PrivacyPolicy = () => {
  return (
    <Container className="my-5 text-start" >
      <h1 className="mb-4 fw-bold text-info">Privacy Policy</h1>
      <p>
        This Privacy Policy describes how we collect, use, and share your personal information when you visit our website, 
        your rights regarding that information, and our obligations to you.
      </p>

      <h2>1. Introduction</h2>
      <p>
        This Privacy Policy outlines our commitment to protecting your privacy and the data we collect. It applies to 
        our portfolio website and all related services.
      </p>

      <h2>2. Information We Collect</h2>
      <h3>Personal Information</h3>
      <p>
        We may collect personal information that you provide directly to us, including:
      </p>
      <ul>
        <li>Name: Bandaru Mahesh</li>
        <li>Email Address: bandarumahesh2024@gmail.com</li>
        <li>Phone Number: 8639449423</li>
      </ul>

      <h3>Non-Personal Information</h3>
      <p>
        We may also collect non-personal information automatically, such as:
      </p>
      <ul>
        <li>IP Address</li>
        <li>Browser Type</li>
        <li>Pages Visited</li>
        <li>Time and Date of Access</li>
      </ul>

      <h3>Cookies and Tracking Technologies</h3>
      <p>
        We use cookies and similar technologies to enhance your experience on our website. You can manage cookie preferences 
        through your browser settings.
      </p>

      <h2>3. How We Use Your Information</h2>
      <p>
        We use the information we collect for various purposes, including:
      </p>
      <ul>
        <li>To provide and maintain our services</li>
        <li>To communicate with you</li>
        <li>To analyze and improve our website and services</li>
        <li>To personalize your experience</li>
        <li>To comply with legal obligations</li>
      </ul>

      <h2>4. Sharing Your Information</h2>
      <h3>Third-Party Service Providers</h3>
      <p>
        We may share your information with third-party service providers who assist us in operating our website or conducting 
        our business. These providers are obligated to protect your information and use it solely for the purpose of providing services to us.
      </p>

      <h3>Legal Compliance</h3>
      <p>
        We may disclose your information if required by law or in response to valid requests by public authorities.
      </p>

      <h3>Business Transfers</h3>
      <p>
        In the event of a merger, acquisition, or asset sale, your information may be transferred. We will notify you before 
        your personal information is transferred and becomes subject to a different privacy policy.
      </p>

      <h2>5. Your Rights</h2>
      <h3>Accessing Your Information</h3>
      <p>
        You have the right to access the personal information we hold about you.
      </p>

      <h3>Data Deletion</h3>
      <p>
        You may request that we delete your personal information, subject to certain exceptions.
      </p>

      <h3>Opt-Out Choices</h3>
      <p>
        You may opt-out of receiving promotional communications from us at any time.
      </p>

      <h2>6. Security of Your Information</h2>
      <p>
        We implement reasonable security measures to protect your information from unauthorized access or use. However, no 
        method of transmission over the Internet or electronic storage is 100% secure.
      </p>

      <h2>7. Children's Privacy</h2>
      <p>
        Our services are not directed to children under 13, and we do not knowingly collect personal information from 
        children under this age.
      </p>

      <h2>8. Misuse of Content</h2>
      <p>
        Any misuse of content on our website, including but not limited to unauthorized copying, distribution, or modification, 
        is strictly prohibited. We reserve the right to take appropriate legal action against anyone who violates this policy.
      </p>

      <h2>9. User Responsibilities</h2>
      <p>
        Users are responsible for maintaining the confidentiality of their account information and for all activities that occur under their account. 
        You agree to notify us immediately of any unauthorized use of your account or any other breach of security.
      </p>

      <h2>10. Data Retention</h2>
      <p>
        We retain your personal information only for as long as necessary to fulfill the purposes for which it was collected, 
        or as required by law.
      </p>

      <h2>11. Third-Party Links</h2>
      <p>
        Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of 
        those sites. We encourage you to read the privacy policies of any linked websites you visit.
      </p>

      <h2>12. Changes to This Privacy Policy</h2>
      <p>
        We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy 
        Policy on this page.
      </p>

      <h2>13. Contact Us</h2>
      <p>
        If you have any questions about this Privacy Policy, please contact us at:
        <br />
        Email: <a href="mailto:bandarumahesh2024@gmail.com">bandarumahesh2024@gmail.com</a>
      </p>

      <h2>14. Governing Law</h2>
      <p>
        This Privacy Policy shall be governed by and construed in accordance with the laws of the jurisdiction in which 
        our company operates, without regard to its conflict of law principles.
      </p>

      <h2>15. Changes to Personal Information</h2>
      <p>
        If you believe that your personal information is incorrect or incomplete, you have the right to request correction 
        of your data.
      </p>

      <h2>16. International Data Transfers</h2>
      <p>
        Your information may be transferred to and processed in countries other than your own. We take appropriate 
        measures to ensure that your information receives an adequate level of protection.
      </p>

      <h2>17. Privacy Policy Acceptance</h2>
      <p>
        By using our website, you signify your acceptance of this Privacy Policy. If you do not agree to this policy, 
        please do not use our website.
      </p>

      <h2>18. Your Consent</h2>
      <p>
        By providing your personal information, you consent to the collection, use, and sharing of that information 
        in accordance with this Privacy Policy.
      </p>

      <h2>19. Data Breaches</h2>
      <p>
        In the unlikely event of a data breach, we will notify affected users as required by applicable laws and 
        regulations.
      </p>

      <h2>20. Marketing Communications</h2>
      <p>
        We may use your information to send you marketing communications about our services and products. You can opt-out 
        of these communications at any time.
      </p>

      <h2>21. Anonymized Data</h2>
      <p>
        We may use anonymized data for research and analysis purposes. This data does not identify you personally and is 
        not subject to this Privacy Policy.
      </p>

      <h2>22. Limitations of Liability</h2>
      <p>
        We shall not be liable for any indirect, incidental, or consequential damages arising from your use of our website 
        or services.
      </p>

      <h2>23. Intellectual Property</h2>
      <p>
        All content, trademarks, and other intellectual property on our website are owned by us or our licensors. You may 
        not use any of our intellectual property without our prior written consent.
      </p>

      <h2>24. User-Generated Content</h2>
      <p>
        If you submit content to our website (such as comments or reviews), you grant us a non-exclusive, worldwide, 
        royalty-free license to use, modify, and display that content.
      </p>

      <h2>25. Severability</h2>
      <p>
        If any provision of this Privacy Policy is found to be invalid or unenforceable, the remaining provisions shall 
        continue to be valid and enforceable.
      </p>
      <hr />
        <Row className="text-center">
          <Col>
            <p>
              <FaCopyright className="me-1" /> {new Date().getFullYear()} Bandaru Mahesh | Olewin | OlewinAI | OlewinTechsolutions | OlewinQ | OlewinTec | Olewin Academy. All Rights Reserved.
            </p>
          </Col>
        </Row>
    </Container>
  );
};

export default PrivacyPolicy;
